<section class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
      <div class="title-block">
        <p class="eyebrow">Website enquiries</p>
        <h1>Review incoming website enquiries</h1>
        <p class="subtitle">External form submissions land here as New until they are archived.</p>
      </div>
    </div>
    <div class="right">
      <button mat-stroked-button color="primary" matTooltip="API endpoints" (click)="openApiDocs()">
        <mat-icon>api</mat-icon> API Endpoints
      </button>
    </div>
  </header>

  <div class="controls">
    <div class="status-cards">
      <button type="button" class="status-card focus" [class.active]="activeTab=='new'" (click)="activateTab('new')">
        <p class="label">New</p>
        <div class="value">{{newCount}}</div>
        <p class="hint">Needs review</p>
      </button>
      <button type="button" class="status-card success" [class.active]="activeTab=='archived'" (click)="activateTab('archived')">
        <p class="label">Archived</p>
        <div class="value">{{archivedCount}}</div>
        <p class="hint">Handled enquiries</p>
      </button>
    </div>
    <div class="meta">
      <ap-search class="search" placeholder="Search enquiries" alignRight="true" (onChange)="search($event)" (cancelled)="searchCancelled()"></ap-search>
    </div>
  </div>

  <mat-spinner *ngIf="isLoading"></mat-spinner>

  <div class="table-card" *ngIf="!isLoading">
    <div class="group-heading">
      <div class="title">{{activeTab === 'archived' ? 'Archived' : 'New'}}</div>
      <div class="hint">{{activeCount}} enquiries</div>
    </div>

    <div class="empty-state" *ngIf="!enquiries?.length">No {{activeTab}} enquiries.</div>

    <ng-container *ngTemplateOutlet="mobileEnquiryCards"></ng-container>

    <table class="enquiries" mat-table [dataSource]="dataSource" *ngIf="enquiries?.length">
      <ng-container matColumnDef="date">
        <td class="date-column" mat-cell *matCellDef="let element">
          <div>{{element.dateCreated | date:'dd-MM-yy'}}</div>
          <div class="muted">{{element.dateCreated | date:'shortTime'}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="enquiry">
        <td class="enquiry-column" mat-cell *matCellDef="let element">
          <div class="contact-name">{{getContact(element)}}</div>
          <div class="contact-links">
            <a *ngIf="element.email" [href]="getEmailHref(element)" (click)="$event.stopPropagation()">{{element.email}}</a>
            <a *ngIf="element.phone" [apPhone]="element.phone" (click)="$event.stopPropagation()">{{element.phone | phone}}</a>
          </div>
          <div class="muted" *ngIf="element.postcode">Postcode {{element.postcode}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="service">
        <td class="service-column" mat-cell *matCellDef="let element">
          <span class="badge">{{element.service || 'Website enquiry'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="spam">
        <td class="spam-column" mat-cell *matCellDef="let element">
          <span
            *ngIf="getMayBeSpam(element) !== null"
            class="spam-status"
            [class.spam-status--spam]="getMayBeSpam(element) === true"
            [class.spam-status--clear]="getMayBeSpam(element) === false">
            <mat-icon>{{getMayBeSpam(element) === true ? 'close' : 'check'}}</mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="message">
        <td class="message-column" mat-cell *matCellDef="let element">{{getMessagePreview(element)}}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <td class="action-column" mat-cell *matCellDef="let element">
          <div class="action-buttons">
            <button *ngIf="activeTab !== 'archived'" mat-stroked-button color="primary" (click)="makeTask(element, $event)" [disabled]="isMakingTask(element)">
              <mat-icon>{{isMakingTask(element) ? 'hourglass_empty' : 'task_alt'}}</mat-icon> Make Task
            </button>
            <button *ngIf="activeTab !== 'archived'" mat-stroked-button color="primary" (click)="archive(element, $event)" [disabled]="isMakingTask(element)">
              <mat-icon>archive</mat-icon> Archive
            </button>
            <button *ngIf="activeTab === 'archived'" mat-stroked-button color="primary" (click)="restore(element, $event)">
              <mat-icon>unarchive</mat-icon> Restore
            </button>
          </div>
        </td>
      </ng-container>

      <tr class="enquiry-row" mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openEnquiryDialog(row)"></tr>
    </table>
  </div>

  <ng-template #mobileEnquiryCards>
    <div class="mobile-enquiry-list" *ngIf="enquiries?.length">
      <article class="mobile-enquiry-card" *ngFor="let enquiry of enquiries" (click)="openEnquiryDialog(enquiry)">
        <div class="mobile-card-topline">
          <span class="badge">{{enquiry.service || 'Website enquiry'}}</span>
          <span class="muted">{{enquiry.dateCreated | date:'dd-MM-yy h:mm a'}}</span>
        </div>
        <h2>{{getContact(enquiry)}}</h2>
        <div class="contact-name">{{getContact(enquiry)}}</div>
        <div class="mobile-spam-row" *ngIf="getMayBeSpam(enquiry) !== null">
          <span
            class="spam-status"
            [class.spam-status--spam]="getMayBeSpam(enquiry) === true"
            [class.spam-status--clear]="getMayBeSpam(enquiry) === false">
            <mat-icon>{{getMayBeSpam(enquiry) === true ? 'close' : 'check'}}</mat-icon>
          </span>
        </div>
        <div class="mobile-card-links">
          <a *ngIf="enquiry.email" [href]="getEmailHref(enquiry)" (click)="$event.stopPropagation()">{{enquiry.email}}</a>
          <a *ngIf="enquiry.phone" [apPhone]="enquiry.phone" (click)="$event.stopPropagation()">{{enquiry.phone | phone}}</a>
        </div>
        <div class="muted" *ngIf="enquiry.postcode">Postcode: {{enquiry.postcode}}</div>
        <p>{{getMessagePreview(enquiry)}}</p>
        <div class="mobile-card-actions">
          <button *ngIf="activeTab !== 'archived'" mat-stroked-button color="primary" (click)="makeTask(enquiry, $event)" [disabled]="isMakingTask(enquiry)">
            <mat-icon>{{isMakingTask(enquiry) ? 'hourglass_empty' : 'task_alt'}}</mat-icon> Make Task
          </button>
          <button *ngIf="activeTab !== 'archived'" mat-stroked-button color="primary" (click)="archive(enquiry, $event)" [disabled]="isMakingTask(enquiry)">
            <mat-icon>archive</mat-icon> Archive
          </button>
          <button *ngIf="activeTab === 'archived'" mat-stroked-button color="primary" (click)="restore(enquiry, $event)">
            <mat-icon>unarchive</mat-icon> Restore
          </button>
        </div>
      </article>
    </div>
  </ng-template>
</section>
